import { SignatureStandardSettings } from 'apps/studio/components/settings/fields/Signature/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Signature/advanced'

export const SignatureSettings = [
  FieldSettingsPanel(SignatureStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
